/**
 * Where Auth0 should send the user after login: path plus query string, so
 * filter state living in the URL survives the round-trip. Shared by every
 * loginWithRedirect call site so the paths can't drift.
 */
export function currentReturnTo(): string {
  return window.location.pathname + window.location.search;
}
